function getLocaleFromUrl() {
    if (typeof window !== 'undefined') {
      const pathSegments = window.location.pathname.split('/');
      return pathSegments[1] || 'en-sg'; // Default to 'en-sg' if no locale is found
    }
    return null;
  }
   
 export function getBVSite() {
    const locale = getLocaleFromUrl();
    
    const localeMap = {
      'ms-my': process.env.BAZAAR_VOICE_URL_MY,
      'en-sg': process.env.BAZAAR_VOICE_URL,
      'th-th': process.env.BAZAAR_VOICE_URL_TH,
      'ph-ph': process.env.BAZAAR_VOICE_URL_PH
    };
   
   return localeMap[locale] || null; // Returns null if locale is not found
  }
   